/*
 * @Author: your name
 * @Date: 2021-12-29 09:32:07
 * @LastEditTime: 2022-01-14 17:48:58
 * @LastEditors: your name
 * @Description: 绘制
 * @FilePath: \smart-community\src\views\map\SatelliteMap\js\Draw.js
 */
import { Vector as VectorLayer } from "ol/layer";
import { Style, Stroke, Fill, Circle, Icon, } from "ol/style";
import Point from "ol/geom/Point";
import { Vector as VectorSource } from "ol/source";
import handleCoordinates from "./handleCoordinates";
import { Draw, Modify } from "ol/interaction";
import Polygon from "ol/geom/Polygon";
import Feature from "ol/Feature";

const { reversePoint, setPoint } = handleCoordinates();
class MyDeaw {
  layerIndex = 0;
  constructor() {
    this.draw = undefined;
    this.drawVector = undefined;

    this.drawLayerArr = [];
    this.drawGeometryArr = [];
    this.delLayer = [];

    this.polygonSource = undefined;
    this.areaVectorLayer = undefined;
    this.areaVectorSource = undefined;
  }

  // 绘制多边形
  addInteractionsApi(myMap, type = 'Polygon', callback, addDel = true, ) {
    const self = this;
    self.polygonSource = new VectorSource();
    self.drawVector = new VectorLayer({
      source: self.polygonSource,
      name: type,
      id: type + self.layerIndex,
      style: new Style({
        fill: new Fill({
          color: type === 'Polygon' ? "rgba( 0, 139, 237, 0.2)" : "rgba( 255, 0, 0, 0.2)"
        }),
        stroke: new Stroke({
          color: type === 'Polygon' ? "#007acc" : 'red',
          width: 2
        }),
        image: new Circle({
          radius: 5,
          fill: new Fill({
            color: "orange"
          })
        })
      })
    });
    myMap.addLayer(self.drawVector);
    self.draw = new Draw({
      source: self.polygonSource,
      type: type
    });
    myMap.addInteraction(self.draw);
    // var modify = new Modify({
    //   source: self.polygonSource
    // });
    // myMap.addInteraction(modify);
    // modify.on("modifyend", async function(evt) {
    //   self.drawGeometryArr = []
    //   self.drawLayerArr.forEach((item) => {
    //     const geometry = item.values_.source.getFeatures()[0].getGeometry();
    //     if (item.values_.name === "Polygon") {
    //       const corrdinates = geometry.getCoordinates();
    //       const point = [];
    //       corrdinates[0].forEach(p => {
    //         point.push(reversePoint(p));
    //       });
    //       self.drawGeometryArr.push(corrdinates)
    //     } else if (item.values_.name === "Circle") {
    //       const corrdinates = geometry.getCenter(); //圆心坐标
    //       const radius = geometry.getRadius(); //圆心坐标
    //       let circleInfo = {
    //         corrdinates: reversePoint(corrdinates),
    //         radius: radius
    //       }
    //       self.drawGeometryArr.push(circleInfo)
    //     } else if (item.values_.name === "LineString") {
    //       const corrdinates = geometry.getCoordinates();
    //       corrdinates[0].forEach(p => {
    //         p = reversePoint(p);
    //       });
    //       self.drawGeometryArr.push(corrdinates)
    //     }
    //   });
    //   callback && callback(self.drawGeometryArr);
    // });
    self.draw.on("drawend", function(evt) {
      self.drawLayerArr.push(self.drawVector);
      const geometry = evt.feature.getGeometry();
      if (type === "Polygon") {
        const corrdinates = geometry.getCoordinates();
        corrdinates[0].forEach(p => {
          p = reversePoint(p);
        });
        const polygonInfo = {
          corrdinates: corrdinates,
        }
        self.drawGeometryArr.push(polygonInfo)
        if (addDel) self.delLayer.push(self.addDeletePoint(myMap, type, corrdinates[0][corrdinates[0].length - 1]))
      } else if (type === "Circle") {
        const corrdinates = geometry.getCenter(); //圆心坐标
        const radius = geometry.getRadius(); //圆心坐标
        const circleInfo = {
          corrdinates: corrdinates,
          radius: radius
        }
        self.drawGeometryArr.push(circleInfo)
        console.log(geometry);
        console.log(geometry.getRadiusSquared_());
        console.log(corrdinates);
        self.delLayer.push(self.addDeletePoint(myMap, type, [geometry.flatCoordinates[2], geometry.flatCoordinates[3]]))
      } else if (type === "LineString") {
        const corrdinates = geometry.getCoordinates();
        corrdinates[0].forEach(p => {
          p = reversePoint(p);
        });
        self.drawGeometryArr.push(corrdinates)
        self.delLayer.push(self.addDeletePoint(myMap, type, corrdinates[corrdinates.length - 1]))
      }
      setTimeout(() => {
        self.draw.finishDrawing();
        myMap.removeInteraction(self.draw);
        self.layerIndex++;
      }, 300);
      callback && callback(self.drawGeometryArr);
    });
    myMap.on("click", e => {
      let pixel = myMap.getEventPixel(e.originalEvent)
      myMap.forEachFeatureAtPixel(pixel, (feature, layer) => {
        //删除绘制的图形
        if (layer) {
          self.drawLayerArr.length > 0 && self.drawLayerArr.forEach((item, index) => {
            if (layer.values_.index === item.values_.id) {
              myMap.removeLayer(layer);
              myMap.removeLayer(item);
              self.drawLayerArr.splice(index, 1)
              self.drawGeometryArr = self.drawGeometryArr.filter((it, inde) => {
                if (inde != index) return it
              })
              callback && callback(self.drawGeometryArr);
            }
          })
        }
      })
    });
  }

  //删除图层
  addDeletePoint(myMap, type, location) {
      const self = this;
      let loctionFlag = 1
      if (type == 'LineString' && self.drawGeometryArr.length > 0) {
        loctionFlag = self.drawGeometryArr[self.drawGeometryArr.length - 1][self.drawGeometryArr[self.drawGeometryArr.length - 1].length - 2][0] - self.drawGeometryArr[self.drawGeometryArr.length - 1][self.drawGeometryArr[self.drawGeometryArr.length - 1].length - 1][0]
      }
      if (type == 'Circle') { loctionFlag = 0 }
      console.log(loctionFlag);
      const deleteSource = new VectorSource({
        features: []
      });
      const deleteLayer = new VectorLayer({
        source: deleteSource,
        name: "del",
        index: type + self.layerIndex,
        style: new Style({
          image: new Icon({
            scale: 0.8,
            anchor: loctionFlag > 0 ? [1.2, 1] : loctionFlag == 0 ? [-0.2, 3] : [-0.2, 1],
            anchorOrigin: "bottom-center", // 锚点源
            src: require(`@/assets/images/map/newIcon/shanchu.png`),
          }),
        })
      });
      const feature = new Feature({
        geometry: new Point(location),
        click: () => {
          myMap.removeLayer(self.delLayer);
          myMap.removeLayer(self.drawLayerArr[self.drawLayerArr.length - 1]);
        }
      });
      deleteSource.addFeature(feature);
      myMap.addLayer(deleteLayer);
      return deleteLayer
    }
    // 清除一个绘制多变型内容
  remDrawApi(myMap, num = -1, callback) {
      const self = this;
      self.draw && self.draw.finishDrawing();
      myMap.removeInteraction(this.draw);
      if (num > -1) {
        console.log(num);
        const layerArr = myMap.getLayers().array_
        let drawlayerArr = layerArr.filter((item) => {
          if (item.values_.name === "Polygon" || item.values_.name === "Circle")
            return item
        })
        myMap.removeLayer(drawlayerArr[num]);
        return
      }
      for (let index = myMap.getLayers().array_.length - 1; index >= 0; index--) {
        const element = myMap.getLayers().array_[index];
        if (element.values_.name === "Polygon" || element.values_.name === "Circle") {
          myMap.removeLayer(element);
          self.drawGeometryArr.pop()
          self.drawLayerArr.pop()
          callback && callback(self.drawGeometryArr);
          break;
        }
      }
    }
    // 清除所有绘制多变型内容
  remAllDrawApi(myMap) {
    const self = this;
    self.draw && self.draw.finishDrawing();
    myMap.removeInteraction(this.draw);
    // console.log();
    for (let index = myMap.getLayers().array_.length - 1; index >= 0; index--) {
      const element = myMap.getLayers().array_[index];
      if (element.values_.name === "Polygon" || element.values_.name === "Circle" || element.values_.name === "del" || element.values_.name === "LineString") {
        myMap.removeLayer(element);
      }
    }
    self.drawGeometryArr = []
    self.drawLayerArr = []
    console.log(myMap.getLayers());
  }

  // 渲染多边形
  renderAreaApi(myMap, list, color) {
    console.log(list);
    if (!list || list.length == 0) return
    const pointList = [];
    for (const item of list) {
      const area = [];
      for (const poi of item) {
        area.push(setPoint(poi));
      }
      pointList.push(area);
    }

    const styles = {
      Polygon: new Style({
        stroke: new Stroke({
          color: color ? color : "rgba( 0, 139, 237, 0.2)",
          width: 1
        }),
        fill: new Fill({
          color: color ? color : "rgba( 0, 139, 237, 0.2)"
        })
      })
    };
    console.log(pointList);
    const features = new Feature(new Polygon(pointList));
    if (this.areaVectorLayer) {
      this.areaVectorSource.addFeature(features);
    } else {
      this.areaVectorSource = new VectorSource();
      this.areaVectorLayer = new VectorLayer({
        source: this.areaVectorSource,
        style: feature => {
          return styles[feature.getGeometry().getType()];
        }
      });
      this.areaVectorSource.addFeature(features);
      myMap.addLayer(this.areaVectorLayer);
    }
  }

  // 清除添加的区域
  remAreaApi(myMap) {
    const self = this;
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        myMap.removeLayer(this.areaVectorLayer);
        self.areaVectorLayer = undefined;
        resolve();
      }, 0);
    });
  }
}
export default MyDeaw;